import { ParsedCoordinatePair } from '../models/coordinate-search.model';

/**
 * Decimal degrees: 45.5017,-73.5673 | 45.5017 -73.5673 | +45.5017,-73.5673
 * Requires a complete lat/lng pair (two numbers).
 */
export function parseDecimalDegrees(input: string): ParsedCoordinatePair | null {
  const trimmed = input.trim();
  if (!trimmed) {
    return null;
  }

  const pairMatch = trimmed.match(
    /^([+-]?\d+(?:\.\d+)?)\s*(?:[,]\s*|\s+)\s*([+-]?\d+(?:\.\d+)?)$/
  );
  if (!pairMatch) {
    return null;
  }

  const lat = Number(pairMatch[1]);
  const lng = Number(pairMatch[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return {
    lat,
    lng,
    sourceFormat: 'dd',
    rawInput: input,
  };
}
